import { render } from "./OrganFormStep3.vue?vue&type=template&id=df6bdcc6&scoped=true&lang=html"
import script from "./OrganFormStep3.vue?vue&type=script&lang=js"
export * from "./OrganFormStep3.vue?vue&type=script&lang=js"

import "./OrganFormStep3.vue?vue&type=style&index=0&id=df6bdcc6&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df6bdcc6"]])

export default __exports__